import React from 'react'
import { useReapitConnect } from '@reapit/connect-session'
import { Button } from '@reapit/elements/core/button'
import { PageLayout } from '@reapit/elements/core/page-layout'
import { reapitConnectBrowserSession } from '../../reapit-connect-session'
import {
  AccessDeniedContainer,
  AccessDeniedDescription,
  AccessDeniedMessagesContainer,
  AccessDeniedTitle,
} from './style'

export const AccessDeniedPage: React.FC = () => {
  const { connectLogoutRedirect } = useReapitConnect(reapitConnectBrowserSession)

  return (
    <PageLayout id="access-denied-page" scroll="self" backgroundColour="--colour-fill-neutral-lightest">
      <PageLayout.BodyRegion>
        <AccessDeniedContainer>
          <AccessDeniedMessagesContainer>
            <AccessDeniedTitle>Access Denied</AccessDeniedTitle>
            <AccessDeniedDescription>
              Your account does not have permission to access the Forms Admin. Please contact your administrator if you
              believe this is an error.
            </AccessDeniedDescription>
          </AccessDeniedMessagesContainer>
          <Button variant="primary" size="medium" onClick={() => connectLogoutRedirect()} type="button">
            Log Out
          </Button>
        </AccessDeniedContainer>
      </PageLayout.BodyRegion>
    </PageLayout>
  )
}

export default AccessDeniedPage
